module.exports = __webpack_public_path__ + "0d7be87fc57ac12ec2626482e9525ebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/news/anything.jpg
// module id = 259
// module chunks = 0